import './StepProgress.css'; // You can style this separately

const steps = [
    'Account Info',
    'Address Info',
    'Contact Info',
    'Requirements',
    'Bill Info',
    'Confirm'
];

const StepProgress = ({ currentStep }) => {
    return (
        <div className="step-progress-container">
            <div className="step-line" />
            {steps.map((label, index) => (
                <div key={index} className={`step ${index + 1 <= currentStep ? 'active' : ''}`}>
                    <div className="circle">{index + 1}</div>
                    <div className="label">{label}</div>
                </div>
            ))}
        </div>
    );
};

export default StepProgress;
